import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
import { NavLink } from 'react-router-dom';

export const WorkpackageListStyled = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[300]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-height: 186px;
`;

export const HeaderStyled = styled(Box).attrs({
  p: { sm: '500' },
  mb: { sm: '100' },
})`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const NavLinkStyled = styled(NavLink)`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    color: inherit;
    display: block;
    position: relative;
    text-decoration: none;
    transition-timing-function: ease-in-out;
    transition-duration: 80ms;
    transition-property: background-color;
    padding-left: ${theme.spacings[400]};
    padding-right: ${theme.spacings[400]};
    padding-top: ${theme.spacings[500]};
    padding-bottom: ${theme.spacings[500]};
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      padding-top: ${theme.spacings[400]};
      padding-bottom: ${theme.spacings[400]};
    }
    &:hover {
      background-color: ${theme.colors.bechtel.blue[100]};
    }
  `}
`;

export const WorkPackageItemStyled = styled(Box).attrs({
  px: { sm: '400' },
  py: { sm: '500' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    position: relative;
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      padding-top: ${theme.spacings[400]};
      padding-bottom: ${theme.spacings[400]};
    }
  `}
`;
